// extracted by mini-css-extract-plugin
export var divider = "_tz-0";